// extracted by mini-css-extract-plugin
export default {"container":"insuranceInformation_container__U2Zrp","innerCard":"insuranceInformation_innerCard__-YNXA","table":"insuranceInformation_table__LqslY"};